import { LinearProgress, Stack } from "@mui/material"
import { reviewDrawerMinWidth } from "../../utils/MissionReviewUtils"
import { useMissionReviewStore } from "../../zstore/MissionReviewStore"
import { ReviewEventCard } from "./ReviewEventCard"

export const ReviewDrawerSplit = () => {
    const selectedReviews = useMissionReviewStore((state) => state.currentPartialLines)

    if (!selectedReviews) {
        return <LinearProgress />
    }

    return (
        <Stack sx={{ minWidth: reviewDrawerMinWidth }}>
            {selectedReviews.map((review, index) => {
                const isLastCard = index === selectedReviews.length - 1
                return <ReviewEventCard key={index} review={review} index={index} isLastCard={isLastCard} />
            })}
        </Stack>
    )
}
